module.exports = __webpack_public_path__ + "static/media/bgame-card.b5e45fc5.png";